module.exports = __webpack_public_path__ + "assets/blob-1.bbdb65e7.svg";